module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex",
    staticStyle: {
      "background-color": "#eee",
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "overflow": "auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8a1f744","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Datenschutz.vue
// module id = 1994
// module chunks = 1